"use strict";
/**
 * @module Services.MissingTopic
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a MISSING_TOPIC request.
 */
var MissingTopicRequest = /** @class */ (function () {
    /**
     * Create a new MissingTopicRequest instance
     *
     * @param sessionID  the session ID
     * @param selector  the topic selector
     * @param cid  the conversation ID
     */
    function MissingTopicRequest(selector, sessionProperties, serverNames, cid) {
        this.selector = selector;
        this.sessionProperties = sessionProperties;
        this.serverNames = serverNames;
        this.cid = cid;
    }
    return MissingTopicRequest;
}());
exports.MissingTopicRequest = MissingTopicRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/missing-topic/missing-topic-request.js
// module id = 1347
// module chunks = 1